var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { useTheme } from "styled-components";
import { useFormContext } from "react-hook-form";
import { Box } from "../../Box";
import { Flex } from "../../Flex";
import { Tooltip } from "../../Tooltip";
import { Icon } from "../../Icon";
import { FieldErrorMessage } from "../FieldErrorMessage";
const MIN_WIDTH = 7;
export const MAX_WIDTH = "100%";
export const HelperText = styled(Box) `
  ${({ theme: { fontSizes, space, colors: { formFieldWrapperColors }, }, }) => ({
    color: formFieldWrapperColors.helperText,
    fontSize: fontSizes[1],
    marginBottom: space[0],
    marginTop: space[2],
})}
  line-height: normal;
`;
const Label = styled(Box) `
  ${({ labelWidth }) => (labelWidth ? `flex: 0 1 ${labelWidth}px` : "flex: 1")}
`;
export const FormFieldWrapper = (_a) => {
    var { children, descriptorId, helperText, inputMaxWidth, label, labelHtmlFor, labelWidth, multiLine, name, required, tooltipText, fixedWidth } = _a, rest = __rest(_a, ["children", "descriptorId", "helperText", "inputMaxWidth", "label", "labelHtmlFor", "labelWidth", "multiLine", "name", "required", "tooltipText", "fixedWidth"]);
    const { formState, getFieldState } = useFormContext();
    const { error } = getFieldState(name, formState);
    const { colors } = useTheme();
    return (React.createElement(Flex, Object.assign({ alignItems: "baseline", flexDirection: multiLine ? "column" : "row", flexWrap: "wrap", pb: 3 }, rest),
        label !== undefined && (React.createElement(Label, { as: "label", "data-testid": `FormFieldLabel-${name}`, htmlFor: labelHtmlFor, labelWidth: labelWidth, minWidth: multiLine ? "100%" : 6, sx: { padding: "8px 0" } },
            label,
            required && (React.createElement(Box, { as: "span", color: colors.formFieldWrapperColors.requiredStar, "data-testid": `FormFieldRequired-${name}` }, "*")),
            tooltipText && (React.createElement(Box, { pl: 2, as: "span" },
                React.createElement(Tooltip, { content: tooltipText, placement: "right" },
                    React.createElement(Box, { "data-testid": `FormFieldTooltip-${name}`, as: "span", verticalAlign: "middle", display: "inline-block", sx: {
                            // to avoid the web-client global svg "display: block" styling
                            "& > svg": {
                                display: "inline-block",
                            },
                        } },
                        React.createElement(Icon, { src: "QuestionMark", size: 16 }))))))),
        React.createElement(Box, { "data-testid": `FormFieldChildren-${name}`, flex: 2, minWidth: multiLine ? "100%" : fixedWidth || MIN_WIDTH, maxWidth: multiLine ? inputMaxWidth || MAX_WIDTH : fixedWidth || MAX_WIDTH },
            children,
            React.createElement(FieldErrorMessage, { name: name, error: error === null || error === void 0 ? void 0 : error.message }),
            helperText && React.createElement(HelperText, { id: descriptorId }, helperText))));
};
